import {
  AssistantCopilotAction,
  AssistantMessage,
} from "@/services/modules/assistant";
import { CopilotCard } from "./CopilotCard";
import { GroundingMeta } from "./GroundingMeta";
import { renderMarkdown } from "@/lib/markdownRenderer";
import { cn } from "@/lib/utils";

type Props = {
  message: AssistantMessage;
  userInitials: string;
  onAction: (action: AssistantCopilotAction) => void;
};

export function ChatMessage({ message, userInitials, onAction }: Props) {
  const isUser = message.role === "user";

  if (message.role === "assistant" && message.viewModel) {
    return (
      <div className="flex gap-2 w-full">
        <CopilotCard
          viewModel={message.viewModel}
          grounding={message.grounding}
          onAction={onAction}
        />
      </div>
    );
  }

  return (
    <div className={cn("flex gap-2 w-full", isUser && "justify-end")}>
      {!isUser && (
        <div className="w-6 h-6 rounded-md bg-blue-500 text-white flex items-center justify-center text-[9px] font-bold shrink-0 mt-0.5 shadow-xs">
          IA
        </div>
      )}

      <div
        className={cn(
          "msg-bubble max-w-[88%]",
          isUser && "bg-blue-500 text-white border-blue-500 shadow-xs"
        )}
      >
        {!isUser ? (
          <>
            <div
              className="text-[12px] leading-relaxed break-words space-y-1"
              dangerouslySetInnerHTML={{ __html: renderMarkdown(message.content) }}
            />
            <GroundingMeta grounding={message.grounding} />
          </>
        ) : (
          <span className="text-[12px] break-words whitespace-pre-wrap">{message.content}</span>
        )}
      </div>

      {isUser && (
        <div className="w-6 h-6 rounded-md bg-slate-700 text-white flex items-center justify-center text-[9px] font-bold shrink-0 mt-0.5 shadow-xs">
          {userInitials}
        </div>
      )}
    </div>
  );
}
